import { Container, IEvent, Meter, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { GameParserModel } from "../../Platform/GameParserModel";
import { HoldAndReSpinView } from "../View/HoldAndReSpinView";
import { gameConstants } from "../../Constants/gameConstants";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { HoldAndRespinReelPanel } from "../ReelPanel/HoldAndRespinReelPanel";
import { HoldAndRespinReelModel } from "../Model/HoldAndRespinReelModel";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";

export class HoldAndReSpinSpinningController {
  private view: HoldAndReSpinView;
  private model: HoldAndRespinReelModel;
  private holdAndRespinReelPanel: HoldAndRespinReelPanel;
  private winCollectionIndex: number = 0;
  private reelSpinDelayTime: number = 1000;
  private bigPrizeData: any[] = [];
  private multiplerData: any[] = [];
  private collectAllData: any[] = [];
  private initialReelSymbol: { offset: number[][]; pos: number; color: string; multiplier: string }[];
  //private holdAndReSpinWin: number = 0;
  constructor(view: HoldAndReSpinView, model: HoldAndRespinReelModel) {
    this.view = view;
    this.model = model;
    this.subscribeEvents();
  }

  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_TRIGGERED_SKULLS, this.showInitialTriggeredSkull, this);
    dispatcher.on(eventDispatchers.SHOW_INITIAL_COINS_ON_REEL, this.showInitialCoinsOnReel, this);
    dispatcher.on(eventDispatchers.INITIATE_REEL_SPINNING, this.onInitiateReelSpinning, this);
    dispatcher.on(eventDispatchers.SHOW_SYMBOL_ON_REEL, this.playBonusLandingAnimation, this);
    dispatcher.on(eventDispatchers.ON_FEATURE_SPIN_COMPLETE, this.SpinComplete, this);
    dispatcher.on(eventDispatchers.PLAY_BONUS_WIN_ANIM, this.playBonusWinAnim, this);
    dispatcher.on(eventDispatchers.START_WIN_COLLECTION, this.startTrailWinCollection, this);
    dispatcher.on(eventDispatchers.END_WIN_COLLECTION_TICKUP, this.onWinCollectionEnd, this);
    dispatcher.on(eventDispatchers.PLAY_ALL_SKULL_ANIM, this.onPlaySkullGlowAnimationForGrand, this);
    dispatcher.on(eventDispatchers.CHECK_FOR_COLLECT_ALL_ON_REEL, this.checkIfOnReelCollectAllSymbol, this);
    dispatcher.on(eventDispatchers.CHECK_FOR_MULTIPLER_ON_REEL, this.checkIfOnReelMultiplierSymbol, this);
  }

  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_TRIGGERED_SKULLS, this.showInitialTriggeredSkull, this);
    dispatcher.off(eventDispatchers.SHOW_INITIAL_COINS_ON_REEL, this.showInitialCoinsOnReel, this);
    dispatcher.off(eventDispatchers.INITIATE_REEL_SPINNING, this.onInitiateReelSpinning, this);
    dispatcher.off(eventDispatchers.SHOW_SYMBOL_ON_REEL, this.playBonusLandingAnimation, this);
    dispatcher.off(eventDispatchers.ON_FEATURE_SPIN_COMPLETE, this.SpinComplete, this);
    dispatcher.off(eventDispatchers.PLAY_BONUS_WIN_ANIM, this.playBonusWinAnim, this);
    dispatcher.off(eventDispatchers.START_WIN_COLLECTION, this.startTrailWinCollection, this);
    dispatcher.off(eventDispatchers.END_WIN_COLLECTION_TICKUP, this.onWinCollectionEnd, this);
    dispatcher.off(eventDispatchers.PLAY_ALL_SKULL_ANIM, this.onPlaySkullGlowAnimationForGrand, this);
     dispatcher.off(eventDispatchers.CHECK_FOR_COLLECT_ALL_ON_REEL, this.checkIfOnReelCollectAllSymbol, this);
     dispatcher.off(eventDispatchers.CHECK_FOR_MULTIPLER_ON_REEL, this.checkIfOnReelMultiplierSymbol, this);
  }
  /**
   * to get bonus symbol positions on reel and to reset winmeter
   */
  private showInitialCoinsOnReel(): void {
    this.initialReelSymbol = (ingenuity.parserModel as GameParserModel).getBonusCoinsInitialData();
    this.showinitialSymbolOnReel(0);
    // dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: "0" });
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.HIDE_BONUS_WIN_MTR_PORTRAIT);
  }

  /**
   * function to show symbol one by one
   * @param index
   */

  private showinitialSymbolOnReel(index: number = 0) {
    if (index < this.initialReelSymbol.length) {
      let coinData: any = this.initialReelSymbol[index];
      if (coinData.color === gameConstants.GOLDEN) {
        this.showBlackPach(coinData.offSet[0], coinData.offSet[1]);
        this.showSkullOnReel(coinData.offSet[0], coinData.offSet[1], coinData.color, index, SlotConstantsBehavior.DURATION_500, "landing_bonus");
        this.playIconLandingSound(coinData.color);
            delayedCall('showAMT',2,()=>{
      killDelayedCall('showAMT');
           this.showCoinWithAmountOnReel(
          coinData.offSet[0],
          coinData.offSet[1],
          coinData.color,
          (coinData.prize * ingenuity.parserModel.getCurrentTotalBet()).toFixed(2).toString(),
          false
        );
    })
        this.model.setLandedColorOffset(coinData.color, coinData.offSet);
        this.model.storeStoppedReels(coinData.position);
        dispatcher.fireEvent(eventDispatchers.UPDATED_COLLECTED_COINS);
      } else {
        this.showinitialSymbolOnReel(++index);
      }
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }
  }

   /**
   * show left image as per triggerd types
   */
  private showImageOnLeft(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    if (triggerType.length == 2) {
      this.view.getContainerByID("baseGameLeftBonusPanelContainer").y = this.view.getContainerByID("baseGameLeftBonusPanelContainer").json.doubleTriggerY;
    } else if (triggerType.length == 3) {
      this.view.getContainerByID("baseGameLeftBonusPanelContainer").y = this.view.getContainerByID("baseGameLeftBonusPanelContainer").json.tripleTriggerY;
    }
    triggerType.reverse().forEach((element: number, index: number) => {
      let charType = this.view.getSpineById(`type_${element}`);
      charType.visible = true;
      charType.setPause(false);
      charType.playAnim("stage_3_idle", true);
      charType.y = gameConstants.LEFT_IMAGE_HEIGHT * index;
    });
  }

  /**
   * to get bonus symbol positions on reel and to reset winmeter
   */
  private showInitialTriggeredSkull(): void {
    this.showImageOnLeft();
    const data: { offSet: number[]; pos: number; color: string }[] = (ingenuity.parserModel as GameParserModel).getBonusTriggeringOffset();
    data.forEach((coinData: any) => {
      this.showBlackPach(coinData.offSet[0], coinData.offSet[1]);
      this.showSkullOnReel(coinData.offSet[0], coinData.offSet[1], coinData.color, -1, 0);
      this.model.setLandedColorOffset(coinData.color, coinData.offSet);
      this.model.storeStoppedReels(coinData.pos);
    }, this);
    dispatcher.fireEvent(eventDispatchers.UPDATED_COLLECTED_COINS);
    // dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: "0" });
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.HIDE_BONUS_WIN_MTR_PORTRAIT);
  }

  /**
   * function will start first spin with delay
   */
  private onInitiateReelSpinning(): void {
    delayedCall(
      "spinClickedInFeature",
      gameConstants.ONE_SECOND_DELAY,
      () => {
        killDelayedCall("spinClickedInFeature");
        this.initializeFeatureReelPanel();
        dispatcher.fireEvent(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT);
        this.onSpinClicked();
      },
      this
    );
  }
  /**
   * To initialize Reel panel Above  the alpha
   */
  private initializeFeatureReelPanel(): void {
    if (!this.holdAndRespinReelPanel) {
      this.holdAndRespinReelPanel = new HoldAndRespinReelPanel(ingenuity.currentGame, this.model);
      this.view.addChildAt(this.holdAndRespinReelPanel, 1);
      this.view.setReelView(this.holdAndRespinReelPanel);
    }
    this.holdAndRespinReelPanel.showView();
    this.holdAndRespinReelPanel.init(1);
    this.holdAndRespinReelPanel.showReels();
  }
  /**
   *  When Spin Btn clicked
   */
  private onSpinClicked(): void {
    if ((ingenuity.parserModel as GameParserModel).getCurrentReSpin() < (ingenuity.parserModel as GameParserModel).getTotalReSpin()) {
      this.reelSpinDelayTime = gameConstants.ONE_SECOND_DELAY;
      dispatcher.fireEvent(eventDispatchers.PARSE_NEXT_RESPIN_DATA);
      this.holdAndRespinReelPanel.featureReelSpin();
      this.stopFeatureReels();
      this.model.increaseReSpinCount();
    } else {
      //(ingenuity.soundManager as any).stop(SoundConstantGame.REEL_LAST_CELL_FILL_SOUND, "soundList_1");
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }
  }

  private stopFeatureReels(): void {
    delayedCall(
      "reelStopDelay",
      300,
      () => {
        killDelayedCall("reelStopDelay");
        this.holdAndRespinReelPanel.stop(this.model.getStoppingGrid());
      },
      this
    );
  }
  /*
   * function is created to do work after spin complete
   * will change the fow as the delay is to hanle spin stop and then call next
   **/
  private SpinComplete(): void {
    //(ingenuity.soundManager as any).stop(SoundConstantGame.REEL_LAST_CELL_FILL_SOUND, "soundList_1");
    //check if bigPrize symbol land on reel
    this.checkIfOnReelBigWinSymbol();
    delayedCall(
      "spinCompleted",
      this.reelSpinDelayTime,
      () => {
        killDelayedCall("spinCompleted");
        dispatcher.fireEvent(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT);
        this.bigPrizeData = [];
        this.collectAllData = [];
        this.multiplerData = [];
        this.autoSpinClicked();
      },
      this
    );
  }

  private checkIfOnReelBigWinSymbol():void{
        if (this.bigPrizeData.length) {
      dispatcher.fireEvent(eventDispatchers.SHOW_AMOUNT_ON_BIG_PRIZE_REEL, this.bigPrizeData);
    } else {
      this.checkIfOnReelCollectAllSymbol();
    }
  }

   private checkIfOnReelCollectAllSymbol():void{
    //check if collectAll symbol land on reel
    if (this.collectAllData.length) {
      dispatcher.fireEvent(eventDispatchers.SHOW_AMOUNT_ON_COLLECT_ALL_REEL, this.collectAllData);
    } else {
      this.checkIfOnReelMultiplierSymbol();
    }
  }

   private checkIfOnReelMultiplierSymbol():void{
    if (this.multiplerData.length) {
      this.getInitialPriceAllSkulls();
      this.getInitialPriceMultiplierSkulls();
      dispatcher.fireEvent(eventDispatchers.SHOW_AMOUNT_ON_MULTIPLER_REEL, this.multiplerData);
    }
  }

  private getInitialPriceAllSkulls():void{
    let allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusWinCoinData();
    allInitialSkulls.forEach((element:any) => {
      for(let i = 0; i<this.multiplerData.length;i++)
      if(element.color !== gameConstants.MULTIPLIER){
        element.prize = element.prize/ this.multiplerData[i].multiplier;
      } else {
        let ifNew = this.checkIfNewCoin(element.position);
        if(ifNew){
          if((element.position <= this.multiplerData[i].position)){
          element.prize = element.prize/ this.multiplerData[i].multiplier;
          }
        } else{
          element.prize = element.prize/ this.multiplerData[i].multiplier;
        }
      }
    });
    (ingenuity.parserModel as GameParserModel).setBonusWinCoinData(allInitialSkulls);

  }

  private getInitialPriceMultiplierSkulls():void{
  for (let i = 0; i < this.multiplerData.length; i++) {
    for (let j = 0; j < this.multiplerData.length; j++) {
      if (this.multiplerData[i].position <= this.multiplerData[j].position) {
        this.multiplerData[i].prize = this.multiplerData[i].prize / this.multiplerData[j].multiplier;
      }
    }
  }
  }
  
  private checkIfNewCoin(position:number):boolean{
    let newCoins = (ingenuity.parserModel as GameParserModel).getBonusCoinsData();
    return newCoins.some(item => item.position === position);
  }
  /*
   * to start spinning again
   */
  private autoSpinClicked(): void {
    dispatcher.fireEvent(eventDispatchers.UPDATED_COLLECTED_COINS);
    this.onSpinClicked();
  }

  /**
   * On Play landing animation after reel stop
   */
  private playBonusLandingAnimation(evt: any): void {
    let spinData = (ingenuity.parserModel as GameParserModel).getBonusCoinsData();
    spinData.forEach((coinData) => {
      if (coinData.position === evt.data) {
        this.showBlackPach(coinData.offSet[0], coinData.offSet[1]);
        this.showSkullOnReel(coinData.offSet[0], coinData.offSet[1], coinData.color, -1, 0, "landing");
        this.playIconLandingSound(coinData.color);
        if (coinData.color === gameConstants.GOLDEN) {
          this.showCoinWithAmountOnReel(
            coinData.offSet[0],
            coinData.offSet[1],
            coinData.color,
            (coinData.prize * ingenuity.parserModel.getCurrentTotalBet()).toFixed(2).toString(),
            true,
            coinData.reward
          );
        } else {
          this.storeUpdatePrizeData(coinData);
        }

        this.model.setLandedColorOffset(coinData.color, coinData.offSet);
        this.model.storeStoppedReels(coinData.position);
        dispatcher.fireEvent(eventDispatchers.RESET_SPIN_LEFT_COUNTER);
      }
    });
  }

  private storeUpdatePrizeData(coinData: any): void {
    if (coinData.color == gameConstants.COLLECT_ALL) {
      this.reelSpinDelayTime = this.reelSpinDelayTime + gameConstants.DURATION_1220;
      let position = coinData.position;
      let offSet = [coinData.offSet[0], coinData.offSet[1]];
      let data = { offSet: offSet, position: position };
      this.collectAllData.push(data);
    } else if (coinData.color == gameConstants.BIG_PRIZE) {
      this.reelSpinDelayTime = this.reelSpinDelayTime + coinData.reward.length * gameConstants.DURATION_1500;
      let position = coinData.position;
      let offSet = [coinData.offSet[0], coinData.offSet[1]];
      let reward = coinData.reward;
      let data = { offSet: offSet, position: position, reward: reward };
      this.bigPrizeData.push(data);
    } else if (coinData.color == gameConstants.MULTIPLIER) {
      let totalCoin = (ingenuity.parserModel as GameParserModel).getBonusWinCoinData().length;
      this.reelSpinDelayTime = this.reelSpinDelayTime + (totalCoin * SlotConstantsBehavior.DURATION_1000);
      let position = coinData.position;
      let offSet = [coinData.offSet[0], coinData.offSet[1]];
      let multiplier = coinData.multiplier;
      let data = { offSet: offSet, position: position, multiplier: multiplier, prize: coinData.prize, reward: coinData.reward };
      this.multiplerData.push(data);
    }
  }

  /**
   * add to play icon drop sound
   */
  private playIconLandingSound(color: string): void {
    if (color === gameConstants.BIG_PRIZE) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.BLUE_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    } else if (color === gameConstants.MULTIPLIER) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.RED_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    } else if (color === gameConstants.COLLECT_ALL) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.GREEN_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    } else {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.BLUE_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
  }

  /**
   * add black patch behind stopped coin
   */
  private showBlackPach(reel: number, pos: number): void {
    let blankReelBG = this.view.getImageJsonAndClone();
    let blankBgContainer = this.view.getContainerByID(gameConstants.SYMBOL_REEL + reel + pos);
    blankBgContainer.addChildAt(blankReelBG, 0);
    delayedCall('showpatch',2,()=>{
      killDelayedCall('showpatch')
      blankReelBG.visible = true;
      
      blankBgContainer.visible = true;
    })
  }

  /**
   * play skull glow before starting celebration
   */
  private onPlaySkullGlowAnimationForGrand(): void {
    this.playSkullGlowAnimationForGrand(0);
  }

  private playSkullGlowAnimationForGrand(index: number) {
    let reelContainer = this.view.getContainerByID("reelMainContainer");
    if (index < reelContainer.children.length) {
      this.playGlowAnimation(index, reelContainer.children[index]);
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_BONUS_OUTRO, "JACKPOT_OUTRO");
      dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_OUTRO, "grand");
    }
  }

  private playGlowAnimation(index: number, element: any): void {
    delayedCall("startSkullGlow", 100, () => {
      killDelayedCall("startSkullGlow");
      this.playSkullGlowAnimationForGrand(++index);
    });
    element.children[1].playAnim("bonus_collect");
    element.children[1].onComplete.addOnce(() => {
      element.children[1].playAnim("idle", true);
    });
  }

  /**
   * method to resume win collection after mini, minor, major jackpot outro
   */
  private onResumeWinCollection(): void {
    let reelContainer = this.view.getContainerByID("reelMainContainer");
    dispatcher.off(eventDispatchers.RESUME_WIN_COLLECTION, this.onResumeWinCollection, this);
    let element = reelContainer.children[this.winCollectionIndex];
    let offset = element.name.split("_")[1].split("");
    this.updateFeatureWin(element.children[3].getValue() / gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER);
    element.children[1].playAnim("landing");
    element.children[1].onComplete.addOnce(() => {
      element.children[1].playAnim("idle", true);
    });
    let data = { col: offset[1], row: offset[0] };
    ++this.winCollectionIndex;
    dispatcher.fireEvent(eventDispatchers.PLAY_WIN_COLLECTION_COIN_TRAIL, data);
  }

  private startTrailWinCollection() {
    let reelContainer = this.view.getContainerByID("reelMainContainer");
    if (this.winCollectionIndex < reelContainer.children.length) {
      let element = reelContainer.children[this.winCollectionIndex];
      if (element.children.length) {
        if (element.children[4]) {
          // if jackpot win on skull show jackpot outro
          let jackpot_type = element.children[4].name.split("_");
          if (jackpot_type[1] == "reward") {
            dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_OUTRO, jackpot_type[0]);
            dispatcher.on(eventDispatchers.RESUME_WIN_COLLECTION, this.onResumeWinCollection, this);
          }
        } else {
          let offset = element.name.split("_")[1].split("");
          element.children[1].playAnim("landing");
          element.children[1].onComplete.addOnce(() => {
            element.children[1].playAnim("idle", true);
          });
          this.updateFeatureWin(element.children[3].getValue() / gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER);
          let data = { col: offset[1], row: offset[0], endPosition: { x: 600, y: 600 }, index: this.winCollectionIndex };
          ++this.winCollectionIndex;

          dispatcher.fireEvent(eventDispatchers.PLAY_WIN_COLLECTION_COIN_TRAIL, data);
        }
      } else {
        ++this.winCollectionIndex;
        this.startTrailWinCollection();
      }
    } else {
      delayedCall("endWinCollection", gameConstants.DELAY_TIME, () => {
        dispatcher.fireEvent(eventDispatchers.UPDATE_TICKUP_WIN_METER, {
          value:
            (ingenuity.parserModel as GameParserModel).getHoldAndRespinTotalWin() +
            (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt(),
          duration: 1,
        });
        killDelayedCall("endWinCollection");
        dispatcher.fireEvent(eventDispatchers.END_WIN_COLLECTION_TICKUP);
      });
    }
  }

  /**
   * method to update the hold and re spin feature win
   * @param multiplier
   */
  private updateFeatureWin(multiplier: number): void {
    if (multiplier) {
      let value = (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt() + multiplier;
      (ingenuity.parserModel as GameParserModel).setBaseGameWinAmt(value);
      dispatcher.fireEvent(eventDispatchers.UPDATE_TICKUP_WIN_METER, {
        value: value,
      });
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    }
  }

  private onWinCollectionEnd(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
  }

  /**
   * add skull symbol on reel
   */

  private showSkullOnReel(reel: number, pos: number, color: string, index = -1, Delaytime: number = 0, landingAnim: string = "") {
    const containerObj = this.view.getContainerByID(gameConstants.SYMBOL_REEL + reel + pos);
    containerObj.visible = true;
    // show skull with fade in effect for now
    if (Delaytime) {
      containerObj.alpha = 0;
      let wildSymAlphaTween = ingenuity.currentGame.add.tween(containerObj).to({ alpha: 1 }, Delaytime, undefined, true, 0);
      wildSymAlphaTween.onComplete.addOnce(() => {
        if (index > -1) {
          this.showinitialSymbolOnReel(++index);
        }
      });
    }
    let bonusCoin = this.view.getSpineJsonAndClone(`${color}_Symbols`);
    if (landingAnim) {
      bonusCoin.playAnim(landingAnim);
      bonusCoin.onComplete.addOnce(() => {
        bonusCoin.playAnim("idle", true);
      });
    } else {
      bonusCoin.playAnim("idle", true);
    }
    containerObj.addChild(bonusCoin);
    if (!containerObj.getChildByName("symbolEffects" + reel + pos)) {
      this.addEffectChild(containerObj, reel, pos);
    }
    bonusCoin.visible = true;
  }

  private addEffectChild(containerObj: Container, reel: number, pos: number): void {
    let symbolEffects = this.view.getSpineJsonAndClone("skullEffects");
    symbolEffects.name = "symbolEffects" + reel + pos;
    containerObj.addChild(symbolEffects);
  }

  /**
   *
   * @param color theme
   * @returns anim name color
   */
  private getColorTheme(color: string): string {
    let colorName: string;
    switch (color) {
      case gameConstants.MULTIPLIER:
        colorName = "Red";
        break;
      case gameConstants.BIG_PRIZE:
        colorName = "Blue";
        break;
      case gameConstants.COLLECT_ALL:
        colorName = "Green";
        break;
      default:
        colorName = "Red";
        break;
    }
    return colorName;
  }

  /**
   * add amount on reel
   * @param reel
   * @param pos
   * @param color
   * @param amount
   * @param isLanding
   */
  private showCoinWithAmountOnReel(
    reel: number,
    pos: number,
    color: string,
    amount: string,
    isLanding: boolean,
    reward: string | number = 0
  ): void {
    const containerObj = this.view.getContainerByID(gameConstants.SYMBOL_REEL + reel + pos);
    //show jackpot if awarded
    let meterBitmapClone: Meter = this.view.getMeterBitmapJsonAndClone(color);
    const amountInCredit: number = Number(amount) * gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER;
    meterBitmapClone.setValue(amountInCredit);
    containerObj.addChild(meterBitmapClone);
    meterBitmapClone.visible = true;
    if (typeof reward == "string") {
      if (reward !== gameConstants.COLLECT_ALL) {
        let colorName = this.getColorTheme(color);
        let rewardImg = this.view.getSpineJsonAndClone("symbol_skull_text");
        rewardImg.name = reward + "_reward";
        containerObj.addChild(rewardImg);
        rewardImg.visible = true;
        rewardImg.playAnim(`${colorName.toLowerCase()}_${reward}`);
      }
    }
  }

  private playBonusWinAnim(evt: IEvent) {
    dispatcher.fireEvent(eventDispatchers.BONUS_SYMBOL_WIN_COMPLETE);
  }
  public resetFeature(): void {
    const reelMainContainer: Container = this.view.getContainerByID("reelMainContainer");
    reelMainContainer.children.forEach((child: Container) => {
      child.children = [];
    });
    this.winCollectionIndex = 0;
    this.model.resetFeatureData();
    this.holdAndRespinReelPanel.unsubscribeEvents();
    this.holdAndRespinReelPanel.hideView();
    this.holdAndRespinReelPanel = null;
    this.stopLeftImageAnimation()
  }

  private stopLeftImageAnimation():void{
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    triggerType.reverse().forEach((element: number) => {
    let charType = this.view.getSpineById(`type_${element}`);
      charType.visible = false;
      charType.setPause(true);
    });
  }
}
